module.exports = __webpack_public_path__ + "img/mr-logo-black.114a6afa.png";